export const LEARNING_APPS = /* GraphQL */ `
  query GetLearningApps {
    getLearningApps {
      learningAppName
      learningAppImage
      subjectName
      subjectImage
      subjectOrder
      timeIntegration
      productivityIntegration
      courses {
        courseName
        activityUnit
        learningUnit
      }
    }
  }
`;
